import './core';

import './builders/display_message_builder';

import './datasources/member_datasource';
import './datasources/display_message_datasource';

import './commands/application_reset_command';
import './commands/heart_beat_command';
import './commands/load_member_configuration_command';
import './commands/load_display_messages_command';
import './commands/load_session_command';
import './commands/send_counselor_message_command';

import './components/application_footer/application_footer';
import './components/application_header/application_header';
import './components/delete_confirmation/delete_confirmation';
import './components/indefinite_article_adder/indefinite_article_adder';
import './components/non_optimized_browser_message/non_optimized_browser_message';
import './components/phx_prompt/phx_prompt';
import './components/user_profile_dropdown/user_profile_dropdown';
import './components/user_session_timer/user_session_timer_component';
import './components/loading_indicator/loading_indicator';

import './configuration/global_notification';
import './configuration/hijack_local_database';
import './configuration/member_configuration';
import './configuration/modal_recovery';
import './configuration/network_failure';
import './configuration/network_url_formatting';
import './configuration/page';
import './configuration/param_serialization';
import './configuration/route_configuration';
import './configuration/routing';
import './configuration/session_timeout_interceptor';
import './configuration/university_text_configuration';

import './directives/disable_animate/disable_animate';

import './interfaces/server_response';

import './modals/contact_counselor/contact_counselor';
import './modals/contact_counselor/contact_counselor_form_model';
import './modals/terms_of_use/terms_of_use';

import './patterns/email_regex';
import './patterns/exam_score_regex';

import './prompts/session_warning/session_warning';

import './servants/hierarchy_category_servant';
import './servants/selection_list_servant';
import './servants/router_helper';

import './services/form_error_service/form_error_service';
import './services/display_message_service';

import './strategies/search_results_strategy';

import './views/oops/oops';
import './views/startup/startup';



// WEBPACK FOOTER //
// ./app/lib/global/main.ts